'use strict';

angular.module('openDataApp')
  .controller('PaymentStatusCtrl', ['$scope', '$stateParams', '$location', 'ApiService', function ($scope, $stateParams, $location, ApiService) {
    $scope.getPaymentStatus = function (token) {
      ApiService.getPaymentStatus(token)
        .then(
          function success(response) {
            if (response.data.response !== undefined && response.data.response === 'paid') {
              $scope.paymentStatus = { success: true };
            } else {
              $scope.paymentStatus = { failed: true };
            }
          },
          function error() {
            $scope.paymentStatus = { failed: true };
          }
        );
      return { pending: true };
    };

    if ($stateParams.token === undefined || $stateParams.token.length === 0) {
      $location.path('/');
    } else {
      $scope.paymentStatus = $scope.getPaymentStatus($stateParams.token);
    }
  }]);
